import React from 'react';
import { TransformCta } from '../TransformCta';
const PAINS = [{
  emoji: '😓',
  text: 'Llegas a un caso complejo y no sabes por dónde empezar el análisis facial.'
}, {
  emoji: '⏰',
  text: 'Inviertes demasiado tiempo revisando una y otra vez el mismo diagnóstico porque no tienes un proceso definido.'
}, {
  emoji: '🤔',
  text: 'La cefalometría dice una cosa… pero el rostro parece decir otra completamente distinta. Y no sabes cuál debe tener mayor peso.'
}, {
  emoji: '💰',
  text: 'Te preocupa cometer un error que termine convirtiéndose en más citas, retratamientos o pérdida de rentabilidad para tu consulta.'
}, {
  emoji: '😣',
  text: 'Presentas el plan de tratamiento con cierta inseguridad porque todavía tienes dudas sobre el diagnóstico.'
}, {
  emoji: '😔',
  text: 'Al terminar la jornada clínica, no puedes evitar preguntarte: “¿Habré pasado algo importante por alto?”'
}];
export function PainPoints() {
  return <section className="w-full bg-white px-4 py-14 sm:py-20" data-id="element-246" data-mp="1n8bphq9jizum">
      <div className="mx-auto max-w-2xl" data-id="element-247" data-mp="1n5qot4kzapyg">
        <h2 className="text-center font-display text-[26px] font-bold leading-[1.15] tracking-tight text-navy-900 sm:text-4xl" data-id="element-248" data-mp="1s64wglio3xvy">
          Si alguna de estas situaciones te resulta familiar…
          <span className="mt-1 block text-gold-600" data-id="element-249" data-mp="21x7xxofieevr">este sistema fue creado para ti.</span>
        </h2>

        <ul className="mt-8 space-y-3" data-id="element-250" data-mp="26wki21ezx7un">
          {PAINS.map(pain => <li key={pain.emoji} className="flex items-start gap-3.5 rounded-2xl border border-navy-100 bg-cream px-4 py-4" data-id="element-251" data-mp="2axe4srgpcgly">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-252" data-mp="2fxa8sqpeg81i">
                {pain.emoji}
              </span>
              <span className="text-[14.5px] leading-relaxed text-navy-700 sm:text-base" data-id="element-253" data-mp="lig2f2n2gri8">
                {pain.text}
              </span>
            </li>)}
        </ul>

        <div className="mt-8 rounded-3xl bg-navy-800 p-5 sm:p-6" data-id="element-254" data-mp="qjna71p7lqow">
          <p className="text-[15px] leading-relaxed text-white/80 sm:text-[17px]" data-id="element-255" data-mp="ihwiuyqzwwgk">
            La buena noticia es que esa incertidumbre no desaparece estudiando más teoría.
          </p>
          <p className="mt-3 text-[15px] font-semibold leading-relaxed text-white sm:text-[17px]" data-id="element-256" data-mp="sfatghq8mr0y">
            Desaparece cuando tienes un método que te indica exactamente qué observar, en qué orden
            hacerlo y cómo convertir cada hallazgo en una decisión clínica respaldada por un proceso.
          </p>
        </div>

        <TransformCta headline="Deja de improvisar el diagnóstico y empieza a seguir un método." label="Quiero el método paso a paso" location="dolores" data-id="element-257" data-mp="xdm3asgj91j6" />
      </div>
    </section>;
}